import { useParams } from 'next/navigation';

export const useCurrentPatientIdParam = () => {
  const { patientId } = useParams();

  if (Array.isArray(patientId)) {
    return undefined;
  }

  return patientId;
};
